/**
 * quick-260513-bx4 — TanStack Query hook for the project engineering-activity endpoint.
 *
 * Query key: ['project-engineering-stats', projectId, window]
 * Disabled when projectId is undefined / non-positive.
 */
import { useQuery } from '@tanstack/react-query';
import {
  getProjectEngineeringStats,
  type ProjectEngineeringStats,
  type ProjectEngineeringStatsWindow,
} from '../services/api/projectEngineeringStats';

export function useProjectEngineeringStats(
  projectId: number | undefined,
  window: ProjectEngineeringStatsWindow,
) {
  return useQuery<ProjectEngineeringStats>({
    queryKey: ['project-engineering-stats', projectId ?? null, window],
    queryFn: () => getProjectEngineeringStats(projectId as number, window),
    enabled: projectId !== undefined && Number.isFinite(projectId) && (projectId as number) > 0,
  });
}
